<template>
<zj-layout-container>
  <zj-layout-main>
    <div class="zj-layout-main-content bgcolor scrollable" ref="container">
      智慧厕所
    </div>
  </zj-layout-main>
</zj-layout-container>
</template>

<script>
export default {
  name: 'ZjSmartToiletHome',
  controller: 'UI',
  action: 'Home'
}
</script>
